// Utils
import { isInstalledPwa } from '../pwaApp/pwaUtils';
import { getIsElectron, getIsSwiftHybrid } from '../hybridApp/hybridAppUtils';

// Constants
import { PLATFORMS } from '../../common/users/userConstants';

/**
 * Gets the appropriate platform string.
 * This is used primarily in analytics, but also occasionally API calls.
 */
export const getApplicationPlatform = () => {
    if (getIsElectron()) return PLATFORMS.APP;
    if (getIsSwiftHybrid()) return PLATFORMS.IPAD;
    if (isInstalledPwa()) return PLATFORMS.PWA;
    return PLATFORMS.WEB;
};
